export default __webpack_public_path__ + "static/media/20210205_170215.5c8cf872.jpg";